<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetContact" });
import { Input, InputText } from "../../../../inputs/index.js";
import SelectMobileCountryCode from "../../../user/components/input-mobile/components/SelectMobileCountryCode.svelte";
import InputMobileNumber from "../../../user/components/input-mobile/components/InputMobileNumber.svelte";
import SelectType from "../select-type/SelectType.svelte";
export let contact;
export let isDisabled = false;
export let isReadonly = false;
export let showType = true;
const DOMAIN = import.meta.env.VITE_DOMAIN;
const MOBILE = contact.mobile ?? { countryCode: void 0, number: void 0 };
const onMobileChange = (MOBILE2) => {
    if (MOBILE2.countryCode === void 0 || MOBILE2.number === void 0) {
        return;
    }
    contact.mobile = {
        countryCode: MOBILE2.countryCode,
        number: MOBILE2.number
    };
};
$: onMobileChange(MOBILE);
</script>

<div class = { `${ showType ? 's8-row-1-with-type' : 's8-row-1' }` }>
    {#if showType}
        <SelectType bind:key = { contact.type } />
    {/if}
    <InputText
        bind:value = { contact.name }
        placeholder = 'Full Name'
        label = 'Name'
        name = 'address.contact.name'
        minLength = { 2 }
        { isDisabled }
        { isReadonly }
        isRequired = { DOMAIN === 'internal' }
    />
    <InputText
        bind:value = { contact.department }
        placeholder = 'Department'
        label = 'Department'
        name = 'address.contact.department'
        minLength = { 2 }
        { isDisabled }
        { isReadonly }
        isRequired = { false }
    />
</div>
<div class = 's8-row-2'>
    <Input
        bind:value = { contact.email }
        autocomplete = 'email'
        keyboard = 'email'
        label = 'Email'
        placeholder = 'Email'
        name = 'address.contact.email'
        type = 'email'
        { isDisabled }
        { isReadonly }
        isRequired = { false }
    />
    <SelectMobileCountryCode
        bind:key = { MOBILE.countryCode }
        { isDisabled }
    />
    <InputMobileNumber
        bind:value = { MOBILE.number }
        { isDisabled }
        { isReadonly }
    />
</div>
{#if DOMAIN === 'internal'}
    <InputText
        bind:value = { contact.notes }
        placeholder = 'Notes about this contact'
        label = 'Notes'
        name = 'address.contact.notes'
        { isDisabled }
        { isReadonly }
        isRequired = { false }
    />
{/if}

<style>

    div[class^='s8-row'] {
        display: grid;
        -moz-column-gap: 10px;
             column-gap: 10px;
    }

        div[class^='s8-row'].s8-row-1 {
            grid-template-columns: repeat(2, 1fr);
        }

        div[class^='s8-row'].s8-row-1-with-type {
            grid-template-columns: 1.5fr 2fr 2fr;
        }

        div[class^='s8-row'].s8-row-2 {
            grid-template-columns: repeat(3, 1fr);
        }</style>